/**
 * Um erro de renderização no assistente não pode derrubar a tela em que a pessoa
 * está trabalhando.
 *
 * O assistente é montado no `AppShell`, acima de TODAS as telas de cliente. Sem um
 * limite próprio, uma exceção no painel — uma resposta do agente num formato que o
 * renderizador não previu, por exemplo — subiria até o `errorElement` do shell e
 * trocaria a aplicação inteira por uma tela de erro. Aqui o assistente some, o erro
 * vai para o console, e o resto continua de pé.
 *
 * Classe porque o React só captura erro de renderização em `componentDidCatch` /
 * `getDerivedStateFromError`; não existe hook equivalente.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface Estado {
  falhou: boolean
}

export class LimiteDoAssistente extends Component<Props, Estado> {
  override state: Estado = { falhou: false }

  static getDerivedStateFromError(): Estado {
    return { falhou: true }
  }

  override componentDidCatch(erro: Error, info: ErrorInfo): void {
    console.error('O assistente de IA falhou ao renderizar e foi ocultado.', erro, info)
  }

  override render(): ReactNode {
    return this.state.falhou ? null : this.props.children
  }
}
